// Small local safety copy, not a second sync engine. Firestore can roll back a
// write rejected by security rules; keep unsaved clinical text across reloads.
// Resolve only after the IndexedDB transaction commits, never on request success.
let database;
function open() {
  if (!database) database = new Promise((resolve, reject) => {
    const request = indexedDB.open('drwaiting-offline-recovery-v1', 1);
    request.onupgradeneeded = () => request.result.createObjectStore('actions', { keyPath: 'operationId' });
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(new Error('Local recovery storage could not open. The form has not been saved.'));
    request.onblocked = () => reject(new Error('Close older dashboard tabs to initialize offline storage.'));
  });
  return database;
}
async function transact(mode, operation) {
  const db = await open();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction('actions', mode);
    const request = operation(transaction.objectStore('actions'));
    transaction.oncomplete = () => resolve(request.result);
    transaction.onabort = () => reject(new Error('Local recovery storage is full or unavailable. Keep the form open.'));
    transaction.onerror = () => {}; // onabort reports the transaction failure.
  });
}
export const recoveryJournal = {
  save: action => transact('readwrite', store => store.put(action)),
  remove: id => transact('readwrite', store => store.delete(id)),
  async list(uid) {
    const actions = await transact('readonly', store => store.getAll());
    return actions.filter(action => action.actorUid === uid);
  },
};
